export default "__VITE_ASSET__WpWEp8vf__"